import {ISVG} from "../../common/Logo/Logo";

export interface IShape1Props extends Pick<ISVG, "fill"> {}

export const Shape7 = ({ fill }: IShape1Props) => {
    const _fill = fill ?? "white;";

    return (
        <svg
            width="79"
            height="72"
            viewBox="0 0 79 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.1085 0.268036C49.7956 0.877954 57.9567 3.58026 64.5654 9.18601C71.8012 15.3237 78.3806 22.9618 78.9525 32.3688C79.5512 42.2153 74.4155 51.3423 67.5646 58.5158C60.485 65.9288 51.4204 72.2037 41.1085 71.9949C30.943 71.7891 22.9925 64.4835 15.7147 57.466C8.30948 50.3256 0.338445 42.5888 0.0129505 32.3688C-0.31931 21.9365 5.77864 12.1123 14.0641 5.64033C21.5635 -0.217637 31.5737 -0.401405 41.1085 0.268036Z"
                fill={_fill}
            />
        </svg>
    );
};
